export default "__VITE_ASSET__CBMg1R0E__"